module.exports = __webpack_public_path__ + "media/images/comunicado_20260605-d978f15e7fb7e729e0603d2ebe9bdf50.jpeg";